import PERMS from "../../constants/permissions";
export var AREA;
(function (AREA) {
    AREA["MYFILES"] = "myfiles";
    AREA["SHAREPAGE"] = "sharepage";
    AREA["SHARED_WITH_ME"] = "shared-with-me";
    AREA["CORPORATE"] = "corporate";
    AREA["STAGING"] = "staging";
    AREA["PORTALS_LIST"] = "portals-list";
    AREA["PORTAL"] = "portal";
    AREA["TRASH"] = "trash";
    AREA["TRASH_MYFILES"] = "myfiles-trash";
    AREA["TRASH_PORTALS_LIST"] = "portals-list-trash";
    AREA["TRASH_PORTAL"] = "portal-trash";
    AREA["TRASH_CORPORATE"] = "corporate-trash";
    AREA["TRASH_STAGING"] = "staging-trash";
})(AREA || (AREA = {}));
export const AREA_ICONS = {
    [AREA.SHARED_WITH_ME]: "share",
    [AREA.SHAREPAGE]: "",
    [AREA.CORPORATE]: "business_center",
    [AREA.STAGING]: "dataset",
    [AREA.MYFILES]: "folder",
    [AREA.PORTALS_LIST]: "cast_connected",
    [AREA.PORTAL]: "",
    [AREA.TRASH]: "delete",
    [AREA.TRASH_MYFILES]: "folder",
    [AREA.TRASH_PORTALS_LIST]: "cast_connected",
    [AREA.TRASH_PORTAL]: "",
    [AREA.TRASH_CORPORATE]: "business_center",
    [AREA.TRASH_STAGING]: "dataset",
};
export const AREA_TEXTS = {
    [AREA.SHARED_WITH_ME]: "Shared with me",
    [AREA.SHAREPAGE]: "",
    [AREA.CORPORATE]: "Corporate",
    [AREA.STAGING]: "Product’s Media",
    [AREA.MYFILES]: "My Files",
    [AREA.PORTALS_LIST]: "Brand Portals",
    [AREA.PORTAL]: "",
    [AREA.TRASH]: "Bin",
    [AREA.TRASH_MYFILES]: "My Files",
    [AREA.TRASH_CORPORATE]: "Corporate",
    [AREA.TRASH_PORTALS_LIST]: "Brand Portals",
    [AREA.TRASH_PORTAL]: "",
    [AREA.TRASH_STAGING]: "Product’s Media",
};
export const AREA_PERMS = {
    [AREA.MYFILES]: null,
    [AREA.CORPORATE]: null,
    [AREA.PORTALS_LIST]: PERMS.medialibrary_touchpoint_manager,
    [AREA.PORTAL]: PERMS.medialibrary_touchpoint_manager,
    [AREA.STAGING]: PERMS.access_staging_area,
    [AREA.TRASH]: null,
    [AREA.TRASH_MYFILES]: null,
    [AREA.TRASH_CORPORATE]: null,
    [AREA.TRASH_PORTALS_LIST]: PERMS.medialibrary_touchpoint_manager,
    [AREA.TRASH_PORTAL]: PERMS.medialibrary_touchpoint_manager,
    [AREA.TRASH_STAGING]: PERMS.access_staging_area,
    [AREA.SHARED_WITH_ME]: null,
    [AREA.SHAREPAGE]: null,
};
export const DOC_COLUMNS_SA = "columns_stagingarea";
export const DOC_FILTERS_SA = "facets_stagingarea";
export const DOC_COLUMNS_SA_TRASH = "columns_stagingarea_trash";
export const DOC_FILTERS_SA_TRASH = "facets_stagingarea_trash";
export const DOC_FILTERS_ML_INBOX = "facets_medialibrary";
export const DOC_FILTERS_ML_TRASH = "facets_medialibrary_trash";
